import axios from "axios";

const API_URL = "https://internal.orevan-prox.com/orevan_requests/request_token/";

const register = (name, email, password, password2) => {
  return axios.post("https://internal.orevan-prox.com/register/" , {
    name,
    email,
    password,
    password2
  })      
  .then((response) => {
    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
      localStorage.setItem("token", JSON.stringify(response.data.token));
      console.log(response);
    }

    return response.data;
  });
};

const login = (email, password) => {
  return axios
    .post('https://internal.orevan-prox.com/login/' , {
        email,
        password,
      })
      .then((response) => {
        if (response.data) {
          localStorage.setItem("user", JSON.stringify(response.data));
          localStorage.setItem("token", JSON.stringify(response.data.token));
          console.log(response);
        }

        return response.data;
      });
};



const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
};

export default AuthService;